// Unpublished Work © 2025 Deere & Company.

import {ColumnHelpers} from '@deere/isg.component-library';
import moment from 'moment';
import {getWorkboardsByMembershipIdFiltered, getWorkboardTemplatesByMembershipId} from 'Services/membership-service';

const TEMPLATE_TYPE = 'TEMPLATE_TYPE';
const DRAFT_TYPE = 'DRAFT_TYPE';

const getDefaultColumns = (translations) => [
    {
        headerName: translations.NAME,
        field: 'name',
        minWidth: 250,
        flex: 1
    },
    ColumnHelpers.localizedDateColumn({
        field: 'formattedDateSelect',
        headerName: translations.DATE
    }, {
        minWidth: 150,
        flex: 1
    }),
    {
        headerName: translations.TIME,
        field: 'startTime',
        minWidth: 150,
        flex: 1,
        valueFormatter: (value) => value === undefined ? null : moment(value).format('h:mm A')
    },
    {
        headerName: translations.JOBS,
        field: 'selectedJobs',
        minWidth: 150,
        flex: 1,
        type: 'number',
        valueGetter: (_, row) => {
            if (row?.workboardTemplateWorkboardId) {
                return row?.selectedJobs?.length || 0;
            }
            if (row?.workboardId) {
                return row?.jobs?.length || 0;
            }
            return null;
        }
    },
    {
        headerName: translations.ONLINK_OPERATOR_COUNT,
        field: 'operatorCount',
        minWidth: 200,
        flex: 1,
        type: 'number',
        valueGetter: (_, row) => {
            if (row?.workboardTemplateWorkboardId) {
                return `${row.operatorCount.assignedOperators} of ${row.operatorCount.suggestedOperators}`;
            }
            if (row.workboardId) {
                let totalOperatorCount = 0,
                    totalWorkItems = 0;

                row?.jobs?.forEach((job) => {
                    totalWorkItems += job?.workItems?.length || 0;
                    totalOperatorCount += job?.jobTemplate?.operatorCount || 0;
                });

                return `${totalWorkItems} of ${totalOperatorCount}`;
            }
            return null;
        }
    },
    ColumnHelpers.localizedDateColumn({
        field: 'lastModified',
        headerName: translations.LAST_MODIFIED,
        datePrecision: 'minute'
    }, {
        minWidth: 150,
        flex: 1
    })
];

const fetchWorkboardDataGrid = async (type, membershipId, translations, signal) => {
    const columns = getDefaultColumns(translations);

    switch (type) {
        case TEMPLATE_TYPE: {
            const {workboardTemplateWorkboards} = await getWorkboardTemplatesByMembershipId(membershipId, signal);

            return {
                columns: columns.filter((col) => col.field !== 'formattedDateSelect'),
                rows: workboardTemplateWorkboards
            };
        }
        case DRAFT_TYPE: {
            const {workboards} = await getWorkboardsByMembershipIdFiltered(membershipId, {
                isDraft: true
            }, signal);

            return {
                columns,
                rows: workboards
            };
        }
        default: return {
            columns: [],
            rows: []
        };
    }
};

export {
    fetchWorkboardDataGrid,
    TEMPLATE_TYPE,
    DRAFT_TYPE
};
